import { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

import { Box, Button, Dialog, Grid, IconButton, InputAdornment, MenuItem, Paper, Select, Slide, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, DialogTitle, DialogContent, DialogActions } from "@mui/material";

import { Edit, Delete } from "@material-ui/icons";
import CircleIcon from '@mui/icons-material/Circle';
import moment from "moment";

import { Pagination } from "../../Pagination";
import ServiceAccountDialog from "../ServiceAccountDialog";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import './ServiceAccounts.css';
import { checkLoggedInUserAuthorizedToViewPage, getDecodeURI, getEncodedURI, useAuthorization  } from '../../../utils/util';
import { getNonAdminPermissions } from "../slice";

import { createServiceAccount, deleteServiceAccount, deleteV2ServiceAccount, getV2ServiceAccounts, updateV2ServiceAccount, topUpParentPool, syncServiceAccounts, ACTION_TYPES } from "../slice";
import SortArrows, { SortOrder } from "../../SortArrows";
import { ServiceAccount } from "../types";
import { toast } from "react-toastify";
import { DeleteConfirmationDialog } from "../DeleteConfirm";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import ServiceAccountWorkflowDialog from "../ServiceAccountWorkflowDialog";
import DownloadCSV, { clearCsvDownload } from "../../DownloadCSV";
import { CsvParameters, downloadAsCSV } from "../../../actions/Users/authenticateCsvDownload";
import convertToPooled from "../../../asset/image/convert-to-pooled.svg"
import AddchartIcon from '@mui/icons-material/Addchart';
import SyncIcon from '@mui/icons-material/Sync';
import DeleteIcon from "../../../asset/image/deleteEnabled.svg";
import edit_icon from "../../../asset/image/edit_icon.svg";
import sync from "../../../asset/image/sync.svg";
import { SERVICE_FUNCTION_TO_FEATURE } from "../../../config";
import _ from "lodash";
import EditActionsPopup from "./EditActionsPopup";
import CreateAccount from "./CreateAccount";
import DownloadButton from "../../CommonComponents/DownloadButton";
import AddButton from "../../../UserScreen/InventoryPage/InventorySettings/components/AddButton/AddButton";
import CustomLoader from "../../Loader/CustomLoaders";

const STARLINK_ADMIN_SF = "starlink-admin";
const STARLINK_FULL_SF = "starlink-full";
const starlinkAdminService = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF]["service"];
const starlinkAdminFunction = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF]["function"];
const starlinkFullService = SERVICE_FUNCTION_TO_FEATURE[STARLINK_FULL_SF]["service"];
const starlinkFullFunction = SERVICE_FUNCTION_TO_FEATURE[STARLINK_FULL_SF]["function"];

const getAccountType = (account) => {
    if (account.type === 'service_account_client' && account?.isPooledAccount) {
        return "Pooled Account"
    } else if (account.type === 'service_account_client') {
        return "Service Account"
    } else if (account.type === 'credential') {
        return "Web Account"
    } else {
        return account.type
    }
}

const convertToCsv = (data: any[][]) => {
    const [_columns, ...rows] = data;
    const csvRows: any[] = [];
    rows.forEach(row => {
        csvRows.push([row[24], row[3]? "Pooled Account" : "Standard Account", row[1], row[0], row[19], row[6], row[21] ? 'Yes' : 'No', row[3] ? `${row[9]?? ""} ${row[10] ? row[10]?.toUpperCase(): ""}` : ""])
    })
    return [['Organization', 'Account Type', 'Account Name', 'Account Number', 'Client ID', 'Version', 'Valid', 'Size'], ...csvRows]
}
interface ServiceAccountsProps {
    authReducer: any;
    errorReducer: any;
    history: any;
    location: any;
    dpIds: string[];
    serviceAccounts: any[];
    v2ServiceAccounts: any[];
    totalServiceAccounts: number;
    totalV2ServiceAccounts: number;
    getV2ServiceAccounts: (parameters: any) => void;
    createServiceAccount: (parameters: ServiceAccount, abortSignal: AbortSignal | undefined) => Promise<any>;
    syncServiceAccounts: (parameters: any) => Promise<any>;
    updateV2ServiceAccount: (any) => void;
    deleteServiceAccount: (id: string) => Promise<any>;
    deleteV2ServiceAccount: (params: any) => void;
    downloadAsCSV: (parameters: any) => void;
    topUpParentPool: (parameters: any) => void;
    newSummaryServiceLine: any;
    addTopUpToParentPool:any;
    syncServiceAccountDetail: any;
    getNonAdminPermissions: (parameters: any) => void;
    creatingV2ServiceAccount: boolean;
    updatingV2ServiceAccount: boolean;
    deletingV2ServiceAccount: boolean;
    subcribingServiceLine: boolean;
    creatingParentPool: boolean;
    updatingParentPool: boolean;
    v2ServiceAccount: any;
    updatedV2ServiceAccount: any;
    deletedServiceAccount: any;
}

export type AccountSortBy = 'user_name' | 'client_id' | 'valid' | 'dpName' | 'type' | 'version' | 'accountName' | 'accountNumber';

function ServiceAccounts(props: ServiceAccountsProps) {

    const { authReducer, errorReducer, history, getNonAdminPermissions, location, dpIds, serviceAccounts, v2ServiceAccounts, totalV2ServiceAccounts, totalServiceAccounts, addTopUpToParentPool, topUpParentPool, getV2ServiceAccounts, 
        createServiceAccount, syncServiceAccounts, updateV2ServiceAccount, deleteServiceAccount, deleteV2ServiceAccount, downloadAsCSV, newSummaryServiceLine, syncServiceAccountDetail, creatingV2ServiceAccount, updatingV2ServiceAccount, deletingV2ServiceAccount, 
        subcribingServiceLine, creatingParentPool, updatingParentPool, v2ServiceAccount, updatedV2ServiceAccount, deletedServiceAccount } = props;

    const queryParams = new Map<string, string>(Object.entries(getDecodeURI(location.search)));
    const params = getDecodeURI(location.search)
    const [selectedOu, setSelectedOu] = useState(authReducer?.selectedOu?.id)
    const [searchText, setSearchText] = useState<string>(queryParams.get('search') || '');
    const [paginationParams, setPaginationParams] = useState<{
        page: number;
        size: number;
        sortBy: AccountSortBy;
        sortOrder: SortOrder;
        search: string;
    }>({
        page: queryParams.get('page') ? Number(queryParams.get('page')) : 1,
        size: queryParams.get('size') ? Number(queryParams.get('size')) : 10,
        sortBy: queryParams.get('sortBy') as AccountSortBy || 'client_id',
        sortOrder: queryParams.get('sortOrder') as SortOrder || 'desc',
        search: queryParams.get('search') || '',
    });
    const [serviceAccountData, setServiceAccountData] = useState({ serviceAccount: [], index: -1, type: null, credential: null, orgId: null, orgName: null })
    const [showPooledDialog, setShowPooledDialog] = useState(false)
    const [usageType, setUsageType] = useState<any>("tb")
    const [openServiceAccountDialog, setOpenServiceAccountDialog] = useState<boolean>(false);
    const [serviceAccountToUpdate, setServiceAccountToUpdate] = useState<any>(null);
    const [toDeleteServiceAcount, setToDeleteServiceAcount] = useState<ServiceAccount | null>(null);
    const [requesAbortController, setRequesAbortController] = useState<AbortController | null>(null);
    const searchTimeoutRef = useRef<any>();
    const [topUpPopUp, setTopUpPopup] = useState<boolean>(false);
    const [accountForTopup, setAccountForTopup] = useState<any>(null);
    const [topUpValue, setTopUpValue] = useState<any>(0);
    const [selectedAccount, setSelectedAccount] = useState<any>({})
    const [editActionsPopup, setEditActionsPopup] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
        onConfirm: {},
    });
    const [showDetails, setShowDetails] = useState(false);
    const [confirmSync, setConfirmSync] = useState(false);
    const { isAdmin } = useAuthorization();
    const dispatch = useDispatch();

    useEffect(()=>{
        if(authReducer?.selectedOu?.id){
        // getNonAdminPermissions({dpId:authReducer?.selectedOu?.id})
        }
    },[authReducer.selectedOu])

    const refreshServiceAccountTable = (samePage: boolean = false) => {
        let _page = paginationParams.page;
        setPaginationParams({
            ...paginationParams,
            page: samePage ? _page : 1
        });
    }

    const handleOpenServiceAccountDialog = () => {
        setRequesAbortController(new AbortController());
        setOpenServiceAccountDialog(true);
    }

    const handleCloseServiceAccountDialog = (refresh: boolean = false) => {
        setOpenServiceAccountDialog(false);
        setServiceAccountToUpdate(null);
        if (refresh) {
            refreshServiceAccountTable();
        }
    }

    const handleSaveServiceAccount = async (serviceAccount) => {
        if (serviceAccountToUpdate) {
            updateV2ServiceAccount(serviceAccount);
            refreshServiceAccountTable()
        } else {
            await createServiceAccount(serviceAccount, requesAbortController?.signal);
            refreshServiceAccountTable()
        }
        setOpenServiceAccountDialog(false);
        setServiceAccountToUpdate(null);
    }

    const handleOnClose = (refresh = false) => {
        setShowPooledDialog(false);
         setSelectedAccount(null)
        if(refresh){
        setShowDetails(false)
        getV2ServiceAccounts({
            dpIds,
            searchText: paginationParams.search,
            sortBy: paginationParams.sortBy,
            sortOrder: paginationParams.sortOrder,
            page: paginationParams.page,
            limit: paginationParams.size
        })
      }
    }

    const handleDeleteServiceAcount = (serviceAccount: ServiceAccount) => {
        setToDeleteServiceAcount(serviceAccount);
    }

    const handleDeleteConfirm = async () => {
        if (toDeleteServiceAcount) {
            let params = {
                dpId: toDeleteServiceAcount?.dpId,
                accountNumber: toDeleteServiceAcount?.accountNumber
            }
            setToDeleteServiceAcount(null);
            deleteV2ServiceAccount(params);
        }
        setToDeleteServiceAcount(null);
    }

    // if (res?.success) {
    //             refreshServiceAccountTable();
    //         } else {
    //             toast.error("Failed to delete serviceAccount", {
    //                 position: toast.POSITION.BOTTOM_LEFT
    //             });
    //         }

    const handleDeleteCancel = () => {
        setToDeleteServiceAcount(null);
    }


    const handleOnSearchClick = () => {
        handleSearch(searchText);
    }

    const handleOnSearchClear = () => {
        setSearchText('');
        handleSearch('');
    }

    const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchText(e.target.value);
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            searchTimeoutRef.current = undefined;
            handleSearch(e.target.value);
        }, 1000)
    }


    const handleSearch = (value: string) => {
        setPaginationParams({
            ...paginationParams,
            search: value,
            page: 1
        });
    }

    const handleChangePage = (event: any, newPage: number) => {
        setPaginationParams({ ...paginationParams, page: newPage });
    };

    const handleChangeSize = (event: any) => {
        setPaginationParams({ ...paginationParams, size: event.target.value, page: 1 });
    };

    const handleChangeSorting = (sortBy: AccountSortBy, sortOrder: SortOrder) => {
        setPaginationParams({
            ...paginationParams,
            sortBy: sortBy,
            sortOrder: sortOrder,
            page: 1
        });
    }

    const updateQueryParams = () => {
        queryParams.set('page', paginationParams.page.toString())
        queryParams.set('size', paginationParams.size.toString())
        queryParams.set('sortBy', paginationParams.sortBy)
        queryParams.set('sortOrder', paginationParams.sortOrder)
        queryParams.set('search', paginationParams.search)
        history.replace({ pathname: location.pathname, search: `?${getEncodedURI(Object.fromEntries(queryParams.entries()))}` });
    }

    useEffect(() => {
        updateQueryParams();
        getV2ServiceAccounts({
            dpIds,
            searchText: paginationParams.search,
            sortBy: paginationParams.sortBy,
            sortOrder: paginationParams.sortOrder,
            page: paginationParams.page,
            limit: paginationParams.size
        })
    }, [dpIds, paginationParams.page,
    paginationParams.size,
    paginationParams.sortBy,
    paginationParams.sortOrder,
    paginationParams.search,]);

    const handleEdit = (serviceAccount: ServiceAccount) => {
        setServiceAccountToUpdate(serviceAccount);
    }

    useEffect(() => {
        if (authReducer.csvDataDownloded && authReducer.csvDataDownloded.length > 0) {
            if (authReducer.csvDownloadId === 'service-account') {
                const [_columns, status] = authReducer.csvDataDownloded;
                if (status[0] === null) {
                    return;
                }
                if (status && status.length > 0) {
                    const rows = status[0];
                    if (rows.length) {
                        DownloadCSV(convertToCsv(authReducer.csvDataDownloded)
                            , {
                                formatters: {
                                    0: 'ESC-COMMA',
                                    2: 'ESC-COMMA'
                                }
                            }
                        );
                    }
                }
                return () => {
                    dispatch(clearCsvDownload())
                }
            }
        }
    }, [authReducer.csvDataDownloded])

    const handleDownloadReport = () => {
        const params: CsvParameters = {
            type: 'QUERY_PG',
            id: 'service-account',
            payload: {
                dpIds: dpIds.map(dpId => `'${dpId}'`).join(','),
                searchText: paginationParams.search,
                sortBy: paginationParams.sortBy,
                sortOrder: paginationParams.sortOrder,
                limit: totalV2ServiceAccounts,
                offset: 0
            },
            queryName: 'GET_SERVICE_CREDENTIAL_ACCOUNTS',
        }
        downloadAsCSV(params);
    }

    useEffect(() => {
        setServiceAccountData({
            serviceAccount: serviceAccounts[serviceAccountData?.index]?.serviceAccounts,
            index: serviceAccountData?.index,
            type: serviceAccounts[serviceAccountData?.index]?.type,
            credential: serviceAccounts[serviceAccountData?.index]?.id,
            orgId: serviceAccounts[serviceAccountData?.index]?.dpId,
            orgName: serviceAccounts[serviceAccountData?.index]?.dpName,
        })
    }, [serviceAccounts])

    useEffect(() => {
        if (syncServiceAccountDetail && Object.keys(syncServiceAccountDetail)?.length) {
            dispatch({ type: ACTION_TYPES.SYNC_SERVICE_ACCOUNTS, payload: {} })
            toast.success(`Sync will complete in a few minutes`, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
        }
    }, [syncServiceAccountDetail])
    
    const handleTopUp = async (serviceAccount) => {
        let params ={
            organizationId: selectedOu ? selectedOu : "",
            accountNumber: serviceAccount?.accountNumber,
            unit: usageType,
            topup: topUpValue,
            credentialId: "",
            serviceLineNumber:"",
            parentPoolId: serviceAccount?.parentPoolId
        }
        await topUpParentPool(params)
        
        setTopUpPopup(false);
        setAccountForTopup(null);
        dispatch({ type: ACTION_TYPES.ADD_TOPUP_TO_PARENT_POOL, payload: {} })
        getV2ServiceAccounts({
            dpIds,
            searchText: paginationParams.search,
            sortBy: paginationParams.sortBy,
            sortOrder: paginationParams.sortOrder,
            page: paginationParams.page,
            limit: paginationParams.size
        })
    }

    useEffect(()=>{
        if (!_.isEmpty(addTopUpToParentPool)) {
            toast.success(`Top Up added successfully.`, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
        }
        setTopUpValue(0)
    },[addTopUpToParentPool])

    const handleCloseEditPopUp = () => {
        setEditActionsPopup(false);
    }

    const handleBack = () => {
        setShowDetails(false);
        setServiceAccountData({
          serviceAccount: [],
          index: -1,
          type: null,
          credential: null,
          orgId: null,
          orgName: null,
        });
    }

    useEffect(()=> {
        refreshServiceAccountTable();
    },[v2ServiceAccount, updatedV2ServiceAccount, deletedServiceAccount])

    return (
        <Paper elevation={1} classes={{ root: 'starlink--base--mtb_07x starlink--base--padding_1x add-srcoll-starlink-subtab-pages' }}>
            {/* FILTERS */}
            <Grid item xs={12} sm={12} md={12} lg={12} mb={2} classes={{ root: 'starlink--base--mtb_07x starlink--base--flex--align--center starlink--base--flex--justify--space_between' }}>
                <Grid item xs={4} sm={4} md={4} lg={4}>
                    <Typography component="div" classes={{ root: 'starlink--base--font_1x' }}>
                        SERVICE ACCOUNTS
                    </Typography>
                </Grid>
                <Grid item xs={8} sm={8} md={8} lg={8} classes={{ root: 'starlink--base--flex starlink--base--flex--align--center' }}>
                    <Grid >
                        <Box>
                            <TextField
                                id="search"
                                variant="outlined"
                                placeholder="Type something"
                                autoComplete="off"
                                classes={{ root: "input-box-service" }}
                                size="small"
                                value={searchText}
                                onChange={handleOnSearchChange}
                                onKeyDown={(e) => { if (e.key === 'Enter') { handleOnSearchClick() } }}
                                InputLabelProps={{ className: "serachLabel" }}
                                InputProps={{
                                    className: "serachBar",
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            {!searchText && <SearchIcon
                                                className="cursorPointer input-search-icons" onClick={handleOnSearchClick}
                                            />}
                                            {searchText && <CloseIcon
                                                className="cursorPointer input-search-icons"
                                                onClick={handleOnSearchClear}
                                            />}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    </Grid>
                    {/* link service account button */}
                    <Button variant="contained" disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)}   className="starlink--button_contained--primary" onClick={handleOpenServiceAccountDialog}>
                        Link Service Account
                    </Button>

                    <Button variant="contained" disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)}   className="starlink--button_contained--primary" onClick={() => { setEditActionsPopup(true) }}>
                        Permissions
                    </Button>
                    
                    {totalV2ServiceAccounts > 0 && <DownloadButton handleDownloadReport={handleDownloadReport}/>}
                </Grid>
            </Grid>
            {(creatingV2ServiceAccount || updatingV2ServiceAccount || deletingV2ServiceAccount || subcribingServiceLine || creatingParentPool || updatingParentPool) ? (
                    <CustomLoader
                      showLoader={true}
                      loadingText={
                        "Fetching data please wait..."
                      }
                    />
                  ) : null}
            {showDetails ?
                <Box className="back-header">
                    <IconButton size="small" className="back-icon" onClick={handleBack}>
                        <ChevronLeftIcon fontSize="small" />
                        <ChevronLeftIcon fontSize="small" className="chevron-overlap" />
                    </IconButton>
                    <Typography variant="body2">
                        <span className="back-label">Back to </span>
                        <span className="org-name" onClick={handleBack}>{serviceAccountData?.orgName}</span>
                    </Typography>
                </Box>
                :
                <Pagination count={totalV2ServiceAccounts} onPageChange={handleChangePage} page={paginationParams.page} rowsPerPage={paginationParams.size} onRowsPerPageChange={handleChangeSize} />
            }
            
            {/* SERVICE ACCOUNT TABLE */}
             <Slide direction={'right'} in={!showDetails} mountOnEnter unmountOnExit><TableContainer component={Paper} className="starlink--table_container">
                <Table sx={{ minWidth: 650 }} size="small" aria-label="starlink--service_accounts">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <SortArrows sortBy={paginationParams.sortBy} sortOrder={paginationParams.sortOrder} field="dpName" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">ORGANIZATION</span>
                                </SortArrows>
                            </TableCell>
                            <TableCell>
                                {/* <SortArrows sortBy={paginationParams.sortBy} sortOrder={paginationParams.sortOrder} field="type" onChange={handleChangeSorting}> */}
                                <span className="font-wt-900">ACCOUNT TYPE</span>
                                {/* </SortArrows> */}
                            </TableCell>
                            <TableCell>
                                <SortArrows sortBy={paginationParams.sortBy} sortOrder={paginationParams.sortOrder} field="accountName" onChange={handleChangeSorting}>
                                <span className="font-wt-900">ACCOUNT NAME</span>
                                </SortArrows>
                            </TableCell>
                             <TableCell>
                                <SortArrows sortBy={paginationParams.sortBy} sortOrder={paginationParams.sortOrder} field="accountNumber" onChange={handleChangeSorting}>
                                <span className="font-wt-900">ACCOUNT NUMBER</span>
                                </SortArrows>
                            </TableCell>
                            <TableCell>
                                <SortArrows sortBy={paginationParams.sortBy} sortOrder={paginationParams.sortOrder} field="client_id" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">CLIENT ID</span>
                                </SortArrows>
                            </TableCell>
                            <TableCell>
                                {/* <SortArrows sortBy={paginationParams.sortBy} sortOrder={paginationParams.sortOrder} field="version" onChange={handleChangeSorting}> */}
                                    <span className="font-wt-900">VERSION</span>
                                {/* </SortArrows> */}
                            </TableCell>
                            <TableCell>
                                <SortArrows sortBy={paginationParams.sortBy} sortOrder={paginationParams.sortOrder} field="valid" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">VALID</span>
                                </SortArrows>
                            </TableCell>
                            <TableCell>
                                <span className="font-wt-900">SIZE</span>
                            </TableCell>
                            <TableCell>
                                <span className="font-wt-900">ACTIONS</span>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            v2ServiceAccounts?.length > 0 ? v2ServiceAccounts.map((serviceAccount, index) => {
                                return <><TableRow
                                    key={serviceAccount.id}
                                >
                                    {/* <TableCell className={serviceAccountData?.index ? "accordian-expand no-padding" : 'accordian-expand remove-border-btm'} id={index != 0 ? 'hub-add-padding-top' : ''}>
                                        <IconButton
                                            aria-label="expand row"
                                            size="small"
                                            onClick={() => {
                                                if(serviceAccountData?.index === index) {
                                                    setServiceAccountData({
                                                        serviceAccount: serviceAccount?.serviceAccounts,
                                                        index: -1,
                                                        type: serviceAccount?.type,
                                                        credential: serviceAccount?.id,
                                                        orgId: serviceAccount?.dpId
                                                    })   
                                                }else{
                                                    setServiceAccountData({
                                                        serviceAccount: serviceAccount?.serviceAccounts,
                                                        index: index,
                                                        type: serviceAccount?.type,
                                                        credential: serviceAccount?.id,
                                                        orgId: serviceAccount?.dpId
                                                    })
                                                }
                                            }}
                                        >
                                            { serviceAccountData?.index === index ? <KeyboardArrowUpIcon className="accordian-arrow" /> : <KeyboardArrowRightIcon className="accordian-arrow" />}
                                        </IconButton>
                                    </TableCell> */}
                                    <TableCell>
                                       <div 
                                    //    onClick={()=>{ 
                                    //     setShowDetails(true)
                                    //     setServiceAccountData({
                                    //         serviceAccount: serviceAccount?.serviceAccounts,
                                    //         index: -1,
                                    //         type: serviceAccount?.type,
                                    //         credential: serviceAccount?.id,
                                    //         orgId: serviceAccount?.dpId,
                                    //         orgName: serviceAccount?.dpName
                                    //     }) }}
                                        >
                                            {/* org-name */}
                                            <div className="">{serviceAccount.dpName}</div> 
                                        </div> 
                                    </TableCell>
                                    <TableCell>
                                        {serviceAccount?.isPooledAccount ? "Pooled Account" : "Standard Account"}
                                    </TableCell>
                                    <TableCell>
                                        {serviceAccount?.accountName ?? "-"}
                                    </TableCell>
                                    <TableCell>
                                        {serviceAccount?.accountNumber ?? "-"}
                                    </TableCell>
                                    <TableCell>
                                        {serviceAccount?.client_id ? 
                                            `****${serviceAccount?.client_id?.slice(-4)}` 
                                            : '-'}
                                    </TableCell>
                                    <TableCell>
                                        {serviceAccount?.version ?? "-"}
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title={serviceAccount.valid ? 'Valid' : 'Invalid'}>
                                            <Grid classes={{ root: 'starlink--base--flex--column starlink--base--flex--align--center' }}>
                                                <CircleIcon className="starlink--circle_icon starlink--service_accounts--valid_status" fontSize="small" sx={{ color: serviceAccount.valid ? 'green' : 'red' }} /> {serviceAccount.valid ? 'Yes' : 'No'}
                                            </Grid>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        {serviceAccount?.isPooledAccount ? serviceAccount?.poolSize : "-"} {serviceAccount?.isPooledAccount ? serviceAccount?.unit?.toUpperCase() : ""}
                                    </TableCell>
                                    <TableCell>
                                        {/* edit */}
                                        <Tooltip title="Edit"><IconButton disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)} size='small' onClick={() => { handleEdit(serviceAccount) }}>
                                            <img src={edit_icon}></img>
                                        </IconButton></Tooltip>
                                        {/* delete */}
                                        <Tooltip title="Delete"><IconButton disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)} size='small' onClick={() => { handleDeleteServiceAcount(serviceAccount) }}>
                                            <img src={DeleteIcon}></img>
                                        </IconButton></Tooltip>
                                        <Tooltip 
                                            title={ serviceAccount?.isPooledAccount ? "Edit Pool Account" : "Convert to Pooled Account"}
                                            //
                                        >
                                            <IconButton className="starlink-service-acc-span">
                                                <img
                                                    src={convertToPooled}
                                                    alt="Edit"
                                                    className={`starlink-service-acc-convert ${!isAdmin ? 'icon-disabled-starlink-serviceAccount' : ''}`}
                                                    onClick={() => {
                                                        if (!isAdmin) return;
                                                        setShowPooledDialog(true);
                                                        setSelectedAccount(serviceAccount);
                                                    }}
                                                />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title={"Sync Starlink Account"}>
                                            <IconButton className="starlink-service-acc-sync" onClick={() => {
                                                setConfirmSync(true)
                                                setSelectedAccount(serviceAccount);
                                            }}>
                                                 
                                                <img src={sync} width="18" height="18"></img>
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                                     </>
                            }) : <TableRow>
                                <TableCell colSpan={6} align='center'>
                                    No data available
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            </Slide>

                <Slide direction={'left'} in={showDetails} mountOnEnter unmountOnExit>
                    <TableContainer component={Paper} className="starlink--table_container">
                    <Table sx={{ minWidth: 550 }} size="small" aria-label="starlink--service_accounts">
                        <TableHead>
                            <TableRow>
                                <TableCell>ACCOUNT NAME</TableCell>
                                <TableCell>ACCOUNT TYPE</TableCell>
                                <TableCell>ACCOUNT NUMBER</TableCell>
                                <TableCell>SIZE</TableCell>
                                {/* <TableCell>TOP UP</TableCell> */}
                                <TableCell>ACTIONS</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {serviceAccountData?.serviceAccount && serviceAccountData?.serviceAccount?.length > 0 &&
                                serviceAccountData?.serviceAccount.map((account: any, ind) => {
                                    return (
                                        <TableRow className="starlink-account-table-row">
                                            <TableCell>
                                                <Tooltip
                                                    classes={{ tooltip: 'starlink--tooltip' }}
                                                    title={account?.isPooledAccount ?
                                                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                            <Table size="small">
                                                                <TableBody>
                                                                    <TableRow>
                                                                        <TableCell>Name </TableCell>
                                                                        <TableCell>{account?.accountName}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell>Size </TableCell>
                                                                        <TableCell>{account?.poolSize} {account?.unit?.toUpperCase()}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell>Start</TableCell>
                                                                        <TableCell>{moment(account?.startDate).format("MM/DD/YYYY")}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell>End</TableCell>
                                                                        <TableCell>{moment(account?.endDate).format("MM/DD/YYYY")}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell>Recurring</TableCell>
                                                                        <TableCell>{account?.isRecurring ? "Yes" : "No"}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell>Plan Info</TableCell>
                                                                        <TableCell>{account?.poolInfo}</TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </div> : <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                            <Table size="small">
                                                                <TableBody>
                                                                    <TableRow>
                                                                        <TableCell>Name </TableCell>
                                                                        <TableCell>{account?.accountName}</TableCell>
                                                                    </TableRow>
                                                                    </TableBody>
                                                                    </Table>
                                                                    </div>
                                                    }
                                                >
                                                    <span>{account?.accountName?.length > 18 ? account?.accountName.slice(0, 18) + "..." : account?.accountName}</span>
                                                </Tooltip></TableCell>
                                            <TableCell>{account?.isPooledAccount ? "Pooled Account" : "Standard Account"}</TableCell>
                                            <TableCell>{account?.accountNumber}</TableCell>
                                            <TableCell>{account?.isPooledAccount ? account?.poolSize : "-"} {account?.isPooledAccount ? account?.unit?.toUpperCase() : ""}</TableCell>
                                            {/* <TableCell>{account?.isPooledAccount ? account?.topups?.reduce((acc, curr) => acc + (curr.topup || 0), 0) : "-"} {account?.isPooledAccount && account?.topups?.reduce((acc, curr) => acc + (curr.topup || 0), 0) > 0 ? "TB" : ""}</TableCell> */}
                                            <TableCell className="starlink-service-acc-head">
                                                 {/* <Tooltip title="Top Up">
                                                    <span>
                                                        <IconButton
                                                            disabled={!account?.isPooledAccount}
                                                            size="small"
                                                             sx={{color: "#264C86"}}
                                                            onClick={() => {
                                                                setTopUpPopup(true);
                                                                setAccountForTopup(account);
                                                            }}
                                                        >
                                                            <AddchartIcon fontSize="small" />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>  */}

                                                <Tooltip title={serviceAccountData?.type === "service_account_client" && account?.isPooledAccount ? "Edit Pool Account" : "Convert to Pooled Account"}>
                                                    <span className="starlink-service-acc-span">
                                                        <img
                                                            src={convertToPooled}
                                                            alt="Edit"
                                                            className={`starlink-service-acc-convert ${!isAdmin ? 'icon-disabled-starlink-serviceAccount' : ''}`}
                                                            onClick={() => {
                                                                if (!isAdmin) return;
                                                                if (serviceAccountData?.type === "service_account_client") {
                                                                    setShowPooledDialog(true);
                                                                    setSelectedAccount(account);
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </Tooltip>

                                                <Tooltip title={"Sync Starlink Account"}>
                                                    <SyncIcon className="starlink-service-acc-sync" onClick={() => {setConfirmSync(true); setSelectedAccount(account);}}/> 
                                                </Tooltip>

                                            </TableCell>

                                        </TableRow>
                                    )
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                </Slide>
              

            {/* DELETE SERVICE ACCOUNT CONFIRMATION */}
            <DeleteConfirmationDialog open={toDeleteServiceAcount != null} itemName="Service Account" itemCaption={toDeleteServiceAcount ? `${toDeleteServiceAcount.dpName} : ${toDeleteServiceAcount.client_id}`: ""} onConfirm={handleDeleteConfirm} onCancel={handleDeleteCancel} />

            {/* SERVICE ACCOUNT EDIT DIALOG */}
            <ServiceAccountDialog open={serviceAccountToUpdate !== null} serviceAccount={serviceAccountToUpdate} onClose={handleCloseServiceAccountDialog} onSave={handleSaveServiceAccount} />

            {/* SERVICE ACCOUNT WORKFLOW DIALOG */}
            <ServiceAccountWorkflowDialog open={openServiceAccountDialog} onClose={handleCloseServiceAccountDialog} onSave={handleSaveServiceAccount} />

            <CreateAccount
                open={showPooledDialog}
                selectedAccount={selectedAccount}
                accountDp={serviceAccountData && serviceAccountData?.orgId}
                accountCredential={serviceAccountData && serviceAccountData?.credential}
                onClose={handleOnClose}
                onSave={handleSaveServiceAccount}
            />

                        {/* SHOW POOL DIALOG */}
            {/* <PooledDialog open={showPooledDialog}
                selectedAccount={selectedAccount}
                accountDp={serviceAccountData && serviceAccountData?.orgId}
                accountCredential={serviceAccountData && serviceAccountData?.credential} */}


            <EditActionsPopup
                open={editActionsPopup} setOpen={() => { handleCloseEditPopUp() }}
                confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} 
            />

            <Dialog
                open={topUpPopUp}
                onClose={() => { setTopUpPopup(false); setAccountForTopup(null); }}
                aria-labelledby="top_up--dialog"
                maxWidth="sm"
                fullWidth
            >
                <div style={{ margin: "30px" }}>
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            <Typography
                                variant="h5"
                                component="div"
                                align="center"
                                style={{ fontWeight: 'bold', color: "#424141" }}
                            >
                                Top Up ({accountForTopup ? accountForTopup?.accountName : ""})
                            </Typography>
                        </Grid>
                        <Grid container xs={12} mt={1} spacing={1} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <Typography fontSize={"0.8rem"}>Note: The top up done here is only for internal purpose and has no bearing on starlink.com portal</Typography>
                        </Grid>
                        <Grid container xs={12} mt={2} spacing={1} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <Grid item xs={4}><Typography>Current Pool Size : {accountForTopup?.poolSize} {accountForTopup?.unit?.toUpperCase()}</Typography></Grid>
                        </Grid>
                        <Grid container xs={12} m={1} spacing={1} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <Grid item xs={1}><Typography>Top Up</Typography></Grid>
                            <Grid item xs={4}>
                                <TextField
                                    type="number"
                                    fullWidth
                                    value={topUpValue === 0 ? "" : topUpValue} 
                                    onChange={(e) => { setTopUpValue(e.target.value) }}
                                    size="small"
                                /></Grid>
                            <Grid item xs={1.5}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={usageType}
                                    onChange={(e) => { setUsageType(e.target.value) }}
                                    displayEmpty
                                >
                                    {/* <MenuItem value="gb">GB</MenuItem> */}
                                    <MenuItem value="tb">TB</MenuItem>
                                </Select>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid classes={{ root: 'starlink--base--flex starlink--base--mtb_07x starlink--base--flex--justify--center' }}>
                        <Button variant="outlined" className='starlink--button--cancel' onClick={() => { setTopUpPopup(false); setAccountForTopup(null); }} >Cancel</Button>
                        <Button variant="contained" className='starlink--button_contained--primary' onClick={() => { handleTopUp(accountForTopup);  }} >Save</Button>
                    </Grid>
                </div>
            </Dialog>
             
            {/* Sycn confirmation Dialog */}
            <Dialog  className="serviceLineDevices-dialog-width" open={confirmSync} onClose={() => { setConfirmSync(false) }}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <Typography component="div">
                        {`The sync will take a few minutes to fetch the starlink details`}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmSync(false)} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                                syncServiceAccounts({ dpId: selectedOu, accountNumber: selectedAccount.accountNumber, op: ["all"]})
                                setConfirmSync(false) 
                                setSelectedAccount(null)
                        }}
                        color="primary"
                        variant="contained"
                    >
                            {"Yes"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    );
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    dpIds: state.starlinkCloud.dpIds,
    serviceAccounts: state.starlinkAdmin.serviceAccounts,
    v2ServiceAccounts: state.starlinkAdmin.v2ServiceAccounts,
    totalV2ServiceAccounts: state.starlinkAdmin.totalV2ServiceAccounts,
    totalServiceAccounts: state.starlinkAdmin.totalServiceAccounts,
    newSummaryServiceLine: state?.authReducer?.newSummaryServiceLine,
    addTopUpToParentPool: state?.starlinkAdmin?.addTopUpToParentPool,
    syncServiceAccountDetail: state.starlinkAdmin.syncServiceAccountDetail,
    creatingV2ServiceAccount: state?.starlinkAdmin.creatingV2ServiceAccount,
    updatingV2ServiceAccount: state?.starlinkAdmin.updatingV2ServiceAccount,
    deletingV2ServiceAccount: state?.starlinkAdmin.deletingV2ServiceAccount,
    subcribingServiceLine: state?.starlinkAdmin.subcribingServiceLine,
    creatingParentPool: state?.starlinkAdmin.creatingParentPool,
    updatingParentPool: state?.starlinkAdmin.updatingParentPool,
    v2ServiceAccount: state?.starlinkAdmin.v2ServiceAccount,
    updatedV2ServiceAccount: state?.starlinkAdmin.updatedV2ServiceAccount,
    deletedServiceAccount: state?.starlinkAdmin.deletedServiceAccount
});

export default withRouter(
    connect(mapStateToProps, {
        getV2ServiceAccounts,
        createServiceAccount,
        updateV2ServiceAccount,
        deleteServiceAccount,
        deleteV2ServiceAccount,
        downloadAsCSV,
        topUpParentPool,
        getNonAdminPermissions,
        syncServiceAccounts
    })(ServiceAccounts)
);